import { Car } from "lucide-react";
import { EquipmentManufacturersData } from "../types/equipmentManufacturers";

export class EquipmentManufacturersTransformer {
  static optionsTransformer() {
    return (equipmentManufacturers: EquipmentManufacturersData[]) => {
      return equipmentManufacturers.map((equipmentManufacturer) => {
        return {
          value: equipmentManufacturer.id,
          label: equipmentManufacturer.display_name,
          icon: <Car strokeWidth={1} size={20} />
        };
      });
    };
  }
}
